<script setup lang="ts">
import { computed, toRef } from 'vue';

import { useProductDetail } from '@/composables/useProductDetail';
import { NutsProduct, NutsProductVariant } from '@/utils/product';

const props = defineProps<{
  isSelected?: boolean;
  product: NutsProduct;
  variant: NutsProductVariant;
}>();

const { calculateCostSavings } = useProductDetail(toRef(props, 'product'));

const saving = computed(() => {
  const savings = calculateCostSavings(props.variant, { quantity: 1 });
  return savings.find((s) => s.type === 'wholesale');
});
</script>

<template>
  <span
    v-if="saving"
    class="px-2 py-1 text-xs font-semibold rounded-2xl"
    :class="isSelected ? 'text-white bg-black' : 'text-black bg-nuts-neutral-200'"
    data-test="wholesale-savings-badge"
  >
    {{ saving.value }}% off
  </span>
</template>
